// GENERATE BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Icon from '../components/Icon';
var svg = function () { return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M22 12.0606C21.9998 10.1378 21.452 8.25534 20.4215 6.63604C19.391 5.01675 17.921 3.72846 16.1854 2.92369C14.4498 2.11892 12.5214 1.83137 10.6285 2.09509C8.73552 2.35881 6.95732 3.16275 5.50437 4.41174C4.05142 5.66072 2.98457 7.30245 2.43013 9.14255C1.87569 10.9827 1.85687 12.9441 2.37591 14.7946C2.89494 16.6451 3.93009 18.3073 5.35881 19.5843C6.78752 20.8612 8.54997 21.6996 10.4375 22V14.9693H7.89833V12.0606H10.4375V9.84368C10.4375 7.32237 11.9308 5.92881 14.2142 5.92881C14.9643 5.93963 15.7126 6.00521 16.4533 6.12501V8.60189H15.1917C14.8119 8.55116 14.4276 8.65427 14.1233 8.88855C13.8191 9.12284 13.6197 9.46911 13.5692 9.85123C13.5549 9.95824 13.5526 10.0665 13.5625 10.174V12.0606H16.3333L15.89 14.9693H13.5567V22C15.91 21.6268 18.0537 20.4206 19.6016 18.5984C21.1495 16.7762 22.0001 14.4578 22 12.0606Z", fill: "#175CD3" }))); };
var FacebookIcon = function (props) { return (React.createElement(Icon, __assign({ component: svg }, props))); };
FacebookIcon.displayName = 'FacebookIcon';
/*
 *  temporary disable this rule for build
 */
// @ts-ignore
export default React.forwardRef(FacebookIcon);
